import React, { Fragment } from 'react';
import {  
    ResponsiveContainer,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    BarChart,
    Label,
    Bar,
    Cell,
    LabelList,
    Text
  } from 'recharts';

const COLORS = [
    '#E30022',
    '#FF8B00',
    '#F2B400',
    '#03C03C',
    '#1F75FE',
    '#431C53'
]; 
  
export default function MonthlyServicePayments(props){

    const {data = []} = props;

    return(
        <Fragment>
            {(data && data.length) ? (
                <div style={{ width: '100%', height: 320 }}>
                <ResponsiveContainer>
                    <BarChart 
                    width={730} 
                    height={250} 
                    data={data} 
                    margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray='3 3' />
                        <XAxis dataKey='month' >
                            <Label value='Month' position='bottom' offset={10} />
                        </XAxis> 
                        <YAxis dataKey='paymentAmount'
                        padding={{ top: 12 }}
                        orientation='left'
                        label={   <Text      x={0}      y={0}      dx={13}      dy={170}      offset={0}      angle={-90}   >Amount ($)</Text>} />
                        <Tooltip />                     
                        <Bar dataKey='paymentAmount' fill='#8884d8' maxBarSize={40} name='Amount ($)'>
                            {data.map((list, key) => (
                            <Cell
                                key={`display-${key}`}
                                fill={COLORS[key % COLORS.length]}
                            />
                            ))}
                            <LabelList dataKey='paymentAmount' position='top' />
                        </Bar>
                    </BarChart>                      
                </ResponsiveContainer>
                </div>
            ) : (
                <p><center>No Data</center></p>
            )}
        </Fragment>
    );
}